import { Route, Switch } from 'react-router-dom'
import * as views from '@/views'

const IframeRouter = () => (
    <Switch>
        <Route path="/iframe/plusminus-drawing-configurator" component={views.PlusminusDrawingConfiguratorIframeContent} exact />
        <Route path="/iframe/plusminus-export3d" component={views.Export3dIframeContent} />
        <Route component={views.NotFoundView} />
    </Switch>	
)

export default IframeRouter